import { Injectable } from "@angular/core";
import { environment } from "~/environments/environment";
import { BaseApiService } from "./base-api.service";
import { KeyHeader } from "./key-header";



@Injectable({ providedIn: 'root' })
export class AuthApiService extends BaseApiService {
  constructor() {
    super({
      baseurl: environment.hostAuth,
      options: {
        timeout: 30000,
        headers: {
          'Content-Type': 'application/json'
        }
      },
      interceptors: {
        "Token": async () => {
          return localStorage.getItem(KeyHeader.token) || "";
        }
      }
    });
  }
}
